// 如意金牌

import MetalAImage from "@/images/metal_a@2x.png";
import MetalBImage from "@/images/metal_b@2x.png";
import MetalCImage from "@/images/metal_c@2x.png";
import MetalDImage from "@/images/metal_d@2x.png";
import MetalEImage from "@/images/metal_e@2x.png";
import MetalFImage from "@/images/metal_f@2x.png";
import MetalGImage from "@/images/metal_g@2x.png";
import MetalHImage from "@/images/metal_h@2x.png";
import MetalSImage from "@/images/metal_s@2x.png";
import MetalTImage from "@/images/metal_t@2x.png";
import MetalWImage from "@/images/metal_w@2x.png";
import MetalXImage from "@/images/metal_x@2x.png";
import MetalAAImage from "@/images/metal_aa@2x.png";
import MetalADImage from "@/images/metal_ad@2x.png";
import MetalBAImage from "@/images/metal_ba@2x.png";

export default [
  {
    shape: "如意",
    name: "如意五福雙獅",
    code: "A",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 30,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalAImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意雙龍獻寶",
    code: "B",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    imagePath: MetalBImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意五福齊臨",
    code: "C",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 30,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalCImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意金福元寶",
    code: "D",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 36,
      },
      gift: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 20,
      },
    },
    imagePath: MetalDImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意雙龍拜塔",
    code: "E",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 24,
      },
    },
    imagePath: MetalEImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意雙龍獻珠",
    code: "F",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    imagePath: MetalFImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意圓融",
    code: "G",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    imagePath: MetalGImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意神龜",
    code: "H",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    imagePath: MetalHImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "如意九品蓮",
    code: "S",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 30,
      },
      godName: {
        lineLimit: 1,
        textLimit: 15,
        maxFontsize: 30,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalSImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "百花如意",
    code: "T",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 30,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalTImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "雙鳳牡丹",
    code: "W",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalWImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "龍福齊天",
    code: "X",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 9,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 20,
      },
    },
    imagePath: MetalXImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "週歲鎖片",
    code: "AA",
    accessory: [5],
    way: ["D"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 11,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 36,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalAAImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "傳統金牌",
    code: "AD",
    accessory: [5],
    way: ["H"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 30,
      },
      godName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    imagePath: MetalADImage,
    engravingContentType: "default",
  },
  {
    shape: "如意",
    name: "日月金牌",
    code: "BA",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 2,
        textLimit: 4,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 36,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 17,
      },
    },
    imagePath: MetalBAImage,
    engravingContentType: "default",
  },
];
